export const roundToTwoDecimals = (n: number) => Math.round(n * 100) / 100;
